const exportDe = {
	export: {
		menuLabel: 'PDF-Export',
		printLabel: 'Drucken',
		exportLabel: 'Exportieren',
		dialogTitle: 'Exportieren',
		pdf: 'PDF herunterladen',
		csv: 'CSV herunterladen',
		format: {
			label: 'Format',
			pdf: 'PDF',
			csv: 'CSV',
		},
		boolean: {
			yes: 'Ja',
			no: 'Nein',
		},
		groupColumn: 'Gruppe',
		failed: 'Export fehlgeschlagen.',
		fallbackTitle: 'Export',
		generatedAt: 'Erstellt am',
		pageOfPages: 'Seite {current} von {total}',
		sort: 'Sortierung',
		activeFilters: 'Filter',
		searchTerm: 'Suche',
		notesColumn: 'Notiz',
		context: {
			account: 'Konto',
			accountType: 'Kontoart',
			building: 'Liegenschaft',
			openingBalance: 'Eröffnungssaldo',
			closingBalance: 'Endsaldo',
			bookingsCount: 'Buchungen',
		},
		summary: {
			title: 'Zusammenfassung',
			sumDebit: 'Σ Soll',
			sumCredit: 'Σ Haben',
			netAmount: 'Saldo der Auswahl',
			selectionHint: '(bezogen auf die angezeigten Buchungen)',
		},
		metadata: {
			tenant: 'Mandant',
			user: 'Benutzer',
			path: 'Pfad',
		},
		largeWarning:
			'Der Export umfasst {count} Datensätze. Das kann etwas dauern.',
		scope: {
			selected: 'Nur ausgewählte',
			currentPage: 'Nur aktuelle Seite',
			all: 'Alle gefilterten Datensätze',
		},
		includeNotes: {
			label: 'Notiz-Spalte hinzufügen',
			hint: 'Fügt rechts eine leere Spalte für handschriftliche Notizen hinzu.',
		},
		groupOnNewPage: {
			label: 'Jede Gruppe auf neuer Seite',
			hint: 'Erzwingt einen Seitenumbruch vor jeder Gruppe. Sonst werden Gruppen nur dann auf eine neue Seite verschoben, wenn sie nicht mehr passen.',
		},
		includeSubtables: {
			label: 'Untertabellen einschließen',
			hint: 'Druckt unter jeder Hauptzeile eine kleinere, eingerückte Tabelle mit den zugeordneten Einträgen (z. B. Personen je Benutzer).',
		},
		titles: {
			updateRequests: 'Datenänderungs-Anfragen',
			meterLevels: 'Zählerstände zur Freigabe',
		},
	},
}

export default exportDe
